<?xml version="1.0" encoding="UTF-8"?>
<svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M23,26 L26,26 L28,22 L28,16 L22,16 L22,22 L25,22 M15,26 L18,26 L20,22 L20,16 L14,16 L14,22 L17,22 L15,26 Z" id="icon"></path>
</svg>